/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type IllegalContentReportViewQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly commentID: string | null;
    readonly refreshStream: boolean | null;
    readonly " $refType": "IllegalContentReportViewQueryLocal";
};
export type IllegalContentReportViewQueryLocal$data = IllegalContentReportViewQueryLocal;
export type IllegalContentReportViewQueryLocal$key = {
    readonly " $data"?: IllegalContentReportViewQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"IllegalContentReportViewQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IllegalContentReportViewQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshStream",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'e6aa715ac6af8074a81c14c69f520eaf';
export default node;
